import MuiGrid, { type GridProps } from '@mui/material/Grid';

export type { GridProps };

const Grid = (props: GridProps) => <MuiGrid {...props} />;

export default Grid;
